/**
 * Returns the styles for the toast based on the variant
 * @param variant - The variant of the toast
 * @returns The styles for the toast
 */
export const getVariantStyles = variant => {
  switch (variant) {
    case 'info':
      return {
        backgroundColor: 'alert-background-info',
        borderBlockColor: 'alert-border-info',
        borderInlineColor: 'alert-border-info'
      };
    case 'warning':
      return {
        backgroundColor: 'alert-background-warning',
        borderBlockColor: 'alert-border-warning',
        borderInlineColor: 'alert-border-warning'
      };
    case 'danger':
      return {
        backgroundColor: 'alert-background-danger',
        borderBlockColor: 'alert-border-danger',
        borderInlineColor: 'alert-border-danger'
      };
    case 'success':
      return {
        backgroundColor: 'alert-background-success',
        borderBlockColor: 'alert-border-success',
        borderInlineColor: 'alert-border-success'
      };
    default:
      {
        const __exhaustiveCheck = variant;
        throw new Error(`Unhandled \`variant\` argument:\n ${variant}`);
      }
  }
};